var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarpentryCarpenterWoodwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 9.5H0.25V11.75H15.75V9.5Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5V8H5.5V9.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0008 7.75039L8.69141 5.65039",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.7496V12.9996H10V14.4996H11.5V15.7496L14.75 14.9996L12.5675 11.749",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.5H3.375C2.90212 6.50074 2.44103 6.35246 2.05721 6.07624C1.67339 5.80001 1.38636 5.40988 1.23688 4.96125L1 4.25C0.801088 4.25 0.610322 4.17098 0.46967 4.03033C0.329018 3.88968 0.25 3.69891 0.25 3.5V3.25C0.25 3.05109 0.329018 2.86032 0.46967 2.71967C0.610322 2.57902 0.801088 2.5 1 2.5H1.75L1.77688 2.46688C2.06891 2.10184 2.45744 1.82599 2.89835 1.67066C3.33927 1.51533 3.8149 1.48674 4.27125 1.58812L4.39125 1.615C4.46452 1.63133 4.54052 1.63095 4.61362 1.61389C4.68672 1.59683 4.75505 1.56354 4.81352 1.51647C4.872 1.4694 4.91912 1.40977 4.9514 1.342C4.98369 1.27423 5.0003 1.20006 5 1.125V1C5 0.801088 5.07902 0.610322 5.21967 0.46967C5.36032 0.329018 5.55109 0.25 5.75 0.25H6.05625C6.19062 0.249958 6.32253 0.286016 6.4382 0.354403C6.55386 0.42279 6.64903 0.520995 6.71375 0.63875L9.03563 4.86062C9.09455 4.9679 9.11208 5.09306 9.0849 5.2124C9.05771 5.33174 8.9877 5.43696 8.88813 5.50812L7.5 6.5Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98639 5H3.67389C3.54424 5.00008 3.41679 4.96656 3.30397 4.9027C3.19114 4.83884 3.0968 4.74682 3.03014 4.63562L2.84701 4.33C2.75162 4.17091 2.71856 3.98212 2.75423 3.80009C2.7899 3.61805 2.89176 3.4557 3.04014 3.34437L3.09889 3.3C3.35853 3.10527 3.67433 3 3.99889 3H5.46389C5.62846 3 5.79049 3.04061 5.9356 3.11823C6.08071 3.19586 6.20443 3.3081 6.29576 3.445L6.86576 4.3C6.90153 4.35391 6.91499 4.41959 6.90334 4.48323C6.89168 4.54687 6.85581 4.60351 6.80326 4.64125L6.57326 4.80875C6.4027 4.93279 6.19729 4.99973 5.98639 5Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarpentryCarpenterWoodwork);
export default __webpack_public_path__ + "static/media/carpentry-carpenter-wood work.1904da27.svg";
export { ForwardRef as ReactComponent };